const regex = /^[A-Za-z0-9_.]+$/;

export const isTranslationKey = (str: string): boolean => regex.test(str);
